exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".device-log[data-v-52d98762] {\n  height: 100%;\n}\n.device-log .header[data-v-52d98762] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  margin-bottom: 17px;\n}\n.device-log .header .title[data-v-52d98762] {\n  font-size: 18px;\n  font-weight: 600;\n  color: #252525;\n}", ""]);

// exports
